export type PgmLevelCatalogEntry = {
  careerPath?: string | null;
  curriculumVersion?: string | null;
  level: number;
  levelCode: string;
};

export const INCOMPLETE_PGM_LEVEL_MESSAGE =
  "This person already has an incomplete level. Finish or close that level before adding another.";

export function formatPgmLevelTitle(level: PgmLevelCatalogEntry): string {
  if (level.level === 0) {
    return "Qualifying Level";
  }

  if (level.careerPath) {
    return `Level ${level.level} ${level.careerPath}`;
  }

  return `Level ${level.level}`;
}

export function buildPgmLevelSelectOptions(levels: PgmLevelCatalogEntry[]) {
  return levels.map((level) => ({
    value: level.levelCode,
    label: `${formatPgmLevelTitle(level)} (${level.levelCode})`
  }));
}

export function personHasIncompletePgmLevel(
  programHistory: Array<{ completed: boolean; endDate?: string | null }>
): boolean {
  return programHistory.some((level) => !level.completed && !level.endDate);
}
